<template>
  <div>
    <div id="content-wrap">
      <h1 class="pageTitle mobileTitle" id="title" role="banner">
        Public Chargers
      </h1>
      <!-- <div style="height: auto; margin-bottom: 20px; width: 100%;" >
        <div id="afdc-stations">
          <div id="afdc-stations-loading">
            Loading alternative fueling station locator...
          </div>
        </div>
        <noscript>
          Please enable JavaScript to view the alternative fueling station locator.
        </noscript>
      </div> -->

      <div style="height: auto; margin-bottom: 20px; width: 100%;" >
        <div id="afdc-stations">
          <div id="afdc-stations-loading">Loading alternative fueling station locator...</div>
        </div>
        <!-- <script type="text/javascript">
          window.afdcStationsOptions = {
            "country":"all","localeCountry":"US","path":"/find/nearest","query":{}
          }
        </script> -->
        <!-- <script async defer src="https://widgets.nlr.gov/afdc/station-locator/assets/embed.js"></script> -->
        <noscript>
          Please enable JavaScript to view the alternative fueling station locator.
        </noscript>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  mounted() {
    this.initStationLocator();
  },
  methods: {
    initStationLocator() {
      // console.log('Initializing station locator');
      // this.s('https://widgets.nlr.gov/afdc/station-locator/css/app.2d4ea1ff.css');
      // this.t('https://widgets.nlr.gov/afdc/station-locator/js/chunk-vendors.c7debdc4.js');
      // this.t('https://widgets.nlr.gov/afdc/station-locator/js/app.13c1cd31.js');
      // this.t('https://widgets.nlr.gov/afdc/station-locator/assets/embed.js');
      window.afdcStationsOptions = {
        country: 'all',
        localeCountry: 'US',
        path: '/find/nearest',
        query: {
          fuel: 'ELEC',
          // location: `${this.center.lat}, ${this.center.lng}`,
        },
      };
      this.t('https://widgets.nlr.gov/afdc/station-locator/assets/embed.js');
    },
    // geolocate() {
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     this.center = {
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude,
    //     };
    //     // console.log('CENTER', this.center);
    //     // Update options fully (not just location property, doesn't seem to update map)
    //     // Just reload the map if we got the position.
    //     this.t('https://widgets.nrel.gov/afdc/station-locator/js/chunk-vendors.c7debdc4.js');
    //     this.t('https://widgets.nrel.gov/afdc/station-locator/js/app.13c1cd31.js');
    //     window.afdcStationsOptions = {
    //       country: 'all',
    //       localeCountry: 'US',
    //       path: '/find/nearest',
    //       query: {
    //         fuel: 'ELEC',
    //         location: `${this.center.lat}, ${this.center.lng}`,
    //       },
    //     };

    //     // this.t('https://widgets.nrel.gov/afdc/station-locator/js/app.13c1cd31.js');
    //     this.logMessage('info', 'Set User Location On Load', JSON.stringify(this.center));
    //     // return `${this.center.lat}, ${this.center.lng}`;
    //   });
    // },
    removeExistingScript(t) {
      if (!t) { return; }
      const existingScript = document.querySelector(`script[src="${t}"]`);
      if (!existingScript) { return; }
      existingScript.remove();
    },
    t(t) {
      this.removeExistingScript(t);
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = !1;
      s.crossOrigin = 'anonymous';
      s.src = t;
      document.body.appendChild(s);
      console.log('Added script', s);
    },
    s(t) {
      const s = document.createElement('link');
      s.rel = 'stylesheet';
      s.href = t;
      document.body.appendChild(s);
    },
  },
  // created() {
  //   console.log('AFDC map created');
  //   // this.geolocate();
  // },
};

// window.onerror = function (message, source) {
//   if (source.includes('nlr.gov')) {
//     // console.log('NREL error caught:', source);
//     return true;
//   }
//   // console.log('CHECK error caught:', source);
//   return false;
// };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

iframe {
  height: calc(100vh - 200px);
}

</style>

<style>
#afdc-stations {
  display: block;
  background: none !important;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  overflow: hidden;
}
#afdc-stations-loading {
  padding: 20px;
}

/* .app-style-root {
  border-radius: 10px !important;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.15) !important;
} */

/* #afdc-stations .afdc-nav-tabs-locator .afdc-nav-item .afdc-nav-link,
#afdc-stations .nav-tabs-locator .nav-item .afdc-nav-link {
  border-radius: 8px !important;
}
#afdc-stations .afdc-nav-tabs-locator .afdc-nav-item .afdc-nav-link.afdc-active,
#afdc-stations .afdc-find-filters,
#afdc-analyze .afdc-filters,
#afdc-stations .afdc-list-results,
#afdc-results-count,
#afdc-stations .nav-tabs-locator .nav-item .nav-link.active,
#afdc-stations .find-filters,
#afdc-analyze .filters,
#afdc-stations .list-results,
#afdc-results-count{
  background: #f4f4f4 !important;
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
}
#afdc-stations .afdc-list-results.afdc-corridor-list,
#afdc-stations .list-results.corridor-list {
  padding-top: 10px !important;
}
#afdc-stations .afdc-nav-tabs-locator .afdc-nav-item .afdc-nav-link.afdc-active,
#afdc-stations .nav-tabs-locator .nav-item .nav-link.active {
  border-radius: 8px 8px 0 0 !important;
  border-top: 1px solid #ddd;
  padding-bottom: 16px !important;
}
#afdc-stations .afdc-row.afdc-fuel-specific-filters,
#afdc-stations .row.fuel-specific-filters {
  background: #e8e8e8;
}
#afdc-footer-actions,
#footer-actions {
  background: none !important;
  padding: 20px 20px 0 20px !important;
}
#afdc-stations #afdc-widget-footer,
#afdc-stations #afdc-widget-footer a,
#widget-footer,
#widget-footer a {
  background: none !important;
  color: #333 !important;
  border: none !important;
}

#afdc-stations #afdc-switch-find-type {
  box-shadow: 0 2px 8px -3px rgba(0,0,0,0.4), 0 0 0 1px rgba(0,0,0,0.05) !important;
}

#afdc-popup-content {
  font-size: 15px !important;
}
#afdc-popup-content h4 {
  font-size: 18px !important;
  font-weight: bold !important;
}
#afdc-popup-content svg {
  margin-top: -4px;
  font-size: 90% !important;
}
#afdc-stations a.afdc-phone-link .afdc-fa-icon {
  margin-top: 2px;
}
#afdc-popup-closer:hover svg {
  color: #555 !important;
}

@media (min-width: 768px) {
  #afdc-stations #afdc-results-count {
    background: none !important;
    border: none !important;
  }
} */
</style>
